/* eslint-disable no-undef */
import React from 'react';
import { Styles } from './styles';
import InfoCard from './InfoCard';
import BathroomsIcon from '@assets/images/shower-ico.png';
import HomeIcon from '@assets/images/home-ico.png';
import BedIcon from '@assets/images/bed-ico.png';
import ParkingIcon from '@assets/images/garage-ico.png';
import SuitesIcon from '@assets/images/bath-ico.png';
import PriceFlag from '@components/PriceFlag';
import {
  IAuthenticatedPropertyDetails,
  IPropertyDetails
} from '@stores/Property/types';

interface InfoDisplayGridProps {
  property: IPropertyDetails | IAuthenticatedPropertyDetails;
}

const InfoDisplayGrid: React.FC<InfoDisplayGridProps> = ({ property }) => {
  const getPropertyPrice = (): string => {
    const formatBRL = (value: number) =>
      value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

    if (property.is_venda && property.valor_substituto) {
      return `a partir de\n${formatBRL(property.valor_substituto)}`;
    }

    const valorExibido = property.valor_venda || property.valor_aluguel || 0;
    return formatBRL(valorExibido);
  };

  const id = property.id || '';
  const title = property.titulo;
  const cod = (() => {
    if (!property.cod_imovel) return '';
    if (typeof property.cod_imovel === 'string') return property.cod_imovel;
    return property.cod_imovel.cod || '';
  })();
  const category = property.tipo_imovel?.titulo;
  const price = getPropertyPrice();
  const area = `${Math.max(0, parseFloat(property.area_construida) || 0)}`;
  const rooms = Math.max(0, property?.quartos || 0);
  const parkingSpaces = Math.max(0, property?.vagas || 0);
  const bathrooms = Math.max(0, property?.banheiros || 0);
  const suites = Math.max(0, property?.suites || 0);

  const codId = `Cód: ${cod}${id}`;
  return (
    <Styles.RightContainer>
      <div>
        <Styles.PropertyCodeBox>
          <Styles.PropertyCodeText>{codId}</Styles.PropertyCodeText>
        </Styles.PropertyCodeBox>
        <Styles.Propertytitle>{title}</Styles.Propertytitle>
        <Styles.IconsContainer>
          <InfoCard iconSrc={HomeIcon} label="Área" value={`${area}m²`} />
          <InfoCard iconSrc={BedIcon} label="Quartos" value={rooms} />
          <InfoCard iconSrc={ParkingIcon} label="Vagas" value={parkingSpaces} />
          <InfoCard
            iconSrc={BathroomsIcon}
            label="Banheiros"
            value={bathrooms}
          />
          <InfoCard iconSrc={SuitesIcon} label="Suítes" value={suites} />
        </Styles.IconsContainer>
      </div>
      {!!property.negotiating && (
        <Styles.NegotiatingBanner>EM NEGOCIAÇÃO</Styles.NegotiatingBanner>
      )}
      <PriceFlag price={price} category={category} />
    </Styles.RightContainer>
  );
};

export default InfoDisplayGrid;
